/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsnewtype2Inputs */

const en_ticketsnewtype2 = /** @type {(inputs: Ticketsnewtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New ticket type`)
};

const de_ticketsnewtype2 = /** @type {(inputs: Ticketsnewtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Ticketart`)
};

/**
* | output |
* | --- |
* | "New ticket type" |
*
* @param {Ticketsnewtype2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsnewtype2 = /** @type {((inputs?: Ticketsnewtype2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsnewtype2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsnewtype2(inputs)
	return de_ticketsnewtype2(inputs)
});
export { ticketsnewtype2 as "ticketsNewType" }